<template>
  <el-button class="jsonretro__copyBtn" plain @click="copyJson">
    Copiar
  </el-button>
</template>

<script>
export default {
  methods: {
    copyJson() {
      let textarea = document.createElement("textarea");
      let jsonTest = document.getElementsByClassName("jsonretro__json")[0];

      textarea.style.position = "fixed";
      textarea.style.top = 0;
      textarea.style.left = 0;
      textarea.style.width = "1em";
      textarea.style.height = "1em";
      textarea.style.padding = 0;
      textarea.style.border = "none";
      textarea.style.outline = "none";
      textarea.style.boxShadow = "none";

      textarea.style.background = "transparent";

      document.body.appendChild(textarea);

      textarea.value = jsonTest.innerHTML;
      textarea.select();

      try {
        document.execCommand("copy");
        this.$message({
          message: "JSON Copiado",
          type: "success"
        });
        document.body.removeChild(textarea);
      } catch (err) {
        this.$message.error(`Oops: ${err}`);
      }
    }
  }
};
</script>
